export default __webpack_public_path__ + "static/media/dark.4d15b764.svg";